import BaseComponent from '/webresources-sources/js/components/base-component';
import { defineComponent } from '/webresources-sources/js/util/jquery';

export default class ParallaxScroll extends BaseComponent {
	properties() {
		return {
			multiplier: 0.5,
			removeOffset: true,
		}
	}

	connected() {
		document.addEventListener(
			'scroll',
			(event) => {
				let scrollDistance = 0;
				if (this.removeOffset) {
					scrollDistance = this.element.getBoundingClientRect().top < window.innerHeight ? this.element.getBoundingClientRect().top : 0;
				} else {
					scrollDistance = window.scrollY;
				}
				this.element.style.setProperty('--parallax-scroll-top', `${Math.round(scrollDistance * this.multiplier) * -1}px`);
			},
			{
				capture: true,
				passive: true,
			},
		);
	}
}

defineComponent('parallax-scroll', ParallaxScroll);
